import * as React from "react";
import classnames from "classnames";
import { Loader } from "@grandvisionhq/common";
import { Container } from "@grandvisionhq/elements";
/* empty css                   */
import { useReviewsContext } from "../../../../ReviewsContext/ReviewsContext/ReviewsContext.js";
import { loadReviewDisplay } from "../../../../ReviewsContext/ReviewsContext/actions.js";
const REVIEW_DISPLAY_ID = "pr-review-display";
const ReviewDisplay = ({ productId, variantId, isSingleColumn }) => {
  const { enabled, dispatch } = useReviewsContext();
  React.useEffect(() => {
    const observer = new MutationObserver(() => {
      if (document.querySelector("#pr-review-snapshot")) {
        const mainDiv = document.querySelector(`#${REVIEW_DISPLAY_ID}`);
        const svgIcons = mainDiv && [...mainDiv.getElementsByTagName("svg")];
        svgIcons?.forEach((svg) => {
          svg.setAttribute("aria-hidden", "true");
        });
        observer.disconnect();
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }, []);
  React.useEffect(() => {
    if (enabled && productId) {
      dispatch(
        loadReviewDisplay({
          id: REVIEW_DISPLAY_ID,
          productId,
          variantId
        })
      );
    }
  }, [dispatch, enabled, productId, variantId]);
  if (!enabled) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classnames("review-display", {
        "review-display__single_column": isSingleColumn
      }),
      "data-t": "review-display"
    },
    /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement("div", { id: REVIEW_DISPLAY_ID }, /* @__PURE__ */ React.createElement(Loader, null)))
  );
};
export {
  REVIEW_DISPLAY_ID,
  ReviewDisplay as default
};
//# sourceMappingURL=ReviewDisplay.js.map
